import { html } from "lit-html"
import { CALENDAR_PATH } from "../constants"

const CalLinks = ({ url, gcal_link }) => html`
  <a role="menuitem" class="dropdown-item" href="${url}${CALENDAR_PATH}">
    +iCal
  </a>
  <a
    role="menuitem"
    class="dropdown-item"
    href=${gcal_link}
    target="_blank"
    rel="noopener noreferrer"
  >
    +Google Calendar
  </a>
`

export default CalLinks
